// English translations
const translations = {
  // Navigation
  dashboard: "Dashboard",
  excavators: "Machines",
  reports: "Reports",
  users: "Users",
  profile: "Profile",
  logout: "Logout",
  login: "Login",
  register: "Register",
  management: "Management",
  analytics: "Analytics",
  hello: "Hello",
  maintenanceReportSystem: "Maintenance Report System",
  changeLanguage: "Change language",

  // Dashboard Specific
  dashboardSubtitle: "Manage your machines and maintenance reports efficiently",
  setLastMaintenanceDate: "Set Last Maintenance Date",
  todaysDate: "Today's Date",
  Saturday: "Saturday",
  Sunday: "Sunday",
  Monday: "Monday",
  Tuesday: "Tuesday",
  Wednesday: "Wednesday",
  Thursday: "Thursday",
  Friday: "Friday",
  notesAndObservations: "Notes and Observations",
  Dashboard: "Dashboard", // Note: Key differs from 'dashboard' only by capitalization
  welcomeBack: "Welcome back",
  selectLanguage: "Select Language",
  createNewReport: "Create New Report",
  viewAllReports: "View All Reports",
  fromLastMonth: "From Last Month",
  requiresAttention: "Requires Attention",
  lastSixMonths: "Last Six Months",
  noRecentReports: "No Recent Reports",
  noPendingReports: "No Pending Reports",
  viewDetails: "View Details",
  entryDetails: "Entry Details",
  viewReports: "View Reports",
  viewAllUsers: "View All Users",
  items: "Items",
  refreshing: "Refreshing...",
  reportStatus: "Report Status",
  allSigned: "All reports are signed",
  excellent: "Excellent",
  signedby: "Signed by",
  excavatorHealth: "Machine Health",
  needsAttention: "Needs Attention",
  healthScore: "Health Score",
  noExcavatorData: "No Machine Data Available",
  noOperatorData: "No Operator Data Available",
  byReportCount: "By Report Count",
  refresh: "Refresh",
  searchExcavators: "Search Machines",
  maintenanceReport: "Maintenance Report",
  created: "Created",
  createdAt: "Created At",
  signReport: "Sign Report",
  signReportDescription: "Please sign the report to approve it. Your signature will be used for report approval.",
  signatureArea: "Signature Area",
  signAndApprove: "Sign and Approve",
  signingAs: "You are signing as",
  useProfileSignature: "Use Profile Signature",
  "Invalid Date": "Invalid Date",
  recentBetriebstagebuch: "Recent Operating Journal Entries",
  details: "Details",
  equipmentAndPersonnel: "Equipment and Personnel",
  Berichtsdetails: "Report Details", // Kept German key as it might be specific
  lastLogin: "Last Login",
  searchByNameEmailRole: "Search by Name, Email, or Role",
  adminFullAccess: "Administrator - Full Access",
  managerAccess: "Manager - Limited Access",
  operatorAccess: "Operator - Limited Access",
  newPasswordLeaveBlank: "New Password (leave blank to keep current)",
  enterFullName: "Enter Full Name",
  noReportsFound: "No Reports Found",
  noReportsCreatedYet: "No Reports Created Yet",
  next: "Next",
  excavatorList: "Machine List",
  approvalConfirmation: "Are you sure you want to approve this report?",
  clearPad: "Clear Signature Pad",
  approve: "Approve",
  setOperational: "Mark as Operational",
  assignOperator: "Assign Operator",
  betriebstagebuchQuickView: "Operating Journal Quick View",
  entryId: "Entry ID",
  yourSignature: "Your Signature",
  security: "Security",
  signatureDescription: "Please add your signature to approve reports.",
  signatureTips: "Signature Tips: Use the pen to draw your signature. Click 'Save Signature' to save.",
  signatureTip1: "Add Signature: Use the pen to draw your signature.",
  signatureTip2: "Click 'Save Signature' to save your signature.",
  signatureTip3: "Click 'Clear Signature' to remove your signature.",
  signatureTip4: "Click 'Save Signature' to save your signature.", // Duplicate tip? Keeping for consistency for now.
  currentSignature: "Current Signature",
  emailCannotBeChanged: "Email address cannot be changed",
  fullName: "Full Name",
  memberSince: "Member Since",
  systemDescription: "The Maintenance Report System is a web application allowing users to create, approve, and manage maintenance reports for machines. It provides a user-friendly interface for monitoring maintenance status and managing reports.",
  registerToJoinDescription: "Register to join the Maintenance Report System and utilize all its features.",
  registerToJoin: "Register to join the Maintenance Report System",
  forgotPassword: "Forgot Password?",
  address: "Herzbergstraße 19-21, 10365 Berlin, Germany", // Assuming address is constant
  contactUs: "Contact Us",
  termsOfService: "Terms of Service",
  privacyPolicy: "Privacy Policy",
  specialChecks: "Special Checks",
  addSpecialCheck: "Add Special Check",

  // Excavator table headers
  manufacturer: "Manufacturer",
  model: "Model",
  serialNumber: "Serial Number",
  year: "Year",
  status: "Status",
  lastMaintenance: "Last Maintenance",
  actions: "Actions",

  // Report table headers
  reportId: "Report ID",
  excavator: "Machine",
  type: "Type",
  date: "Date",
  technician: "Operator", // Updated from "Technician" to "Operator"
  report: "Report",
  machine: "Machine",

  // Actions
  view: "View",
  edit: "Edit",
  delete: "Delete",
  add: "Add",
  addExcavator: "Add Machine",
  addReport: "Add Report",

  // Status options
  operational: "Operational",
  maintenance: "In Maintenance",
  repair: "Under Repair",
  outOfService: "Out of Service",
  signed: "Signed",
  unsigned: "Unsigned",
  approved: "Approved",
  pendingApproval: "Pending Approval",
  completed: "Completed",

  // Form labels
  save: "Save",
  cancel: "Cancel",
  uploadImage: "Upload Image",

  // Other common text
  confirmDelete: "Are you sure you want to delete this item?",
  noDataAvailable: "No data available",
  loading: "Loading...",
  error: "Error",
  success: "Success",

  // 404 Page
  pageNotFound: "Page Not Found",
  pageNotFoundMessage:
    "The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.",
  goToDashboard: "Go to Dashboard",
  goBack: "Go Back",

  // Footer
  version: "Version",

  // User Management
  userManagement: "User Management",
  createUser: "Create User",
  editUser: "Edit User",
  deleteUser: "Delete User",
  name: "Name",
  email: "Email",
  role: "Role",
  password: "Password",
  confirmPassword: "Confirm Password",
  administrator: "Administrator",
  manager: "Manager",
  operator: "Operator",

  // Profile page
  changePassword: "Change Password",
  currentPassword: "Current Password",
  newPassword: "New Password",
  updatePassword: "Update Password",
  userProfile: "User Profile",
  personalDetails: "Personal Details",
  department: "Department",
  phoneNumber: "Phone Number",
  signature: "Signature",
  saveChanges: "Save Changes",
  uploadProfileImage: "Upload Profile Image",

  // Login/Register
  loginToAccess: "Login to access the system",
  createAccount: "Create Account",
  alreadyHaveAccount: "Already have an account?",
  dontHaveAccount: "Don't have an account?",
  enterEmail: "Enter your email",
  enterPassword: "Enter your password",
  enterName: "Enter your name",
  confirmYourPassword: "Confirm your password",
  or: "OR",

  // Dashboard
  welcome: "Welcome back",
  viewProfile: "View Profile",
  quickActions: "Quick Actions",
  recentActivity: "Recent Activity",
  maintenanceStatus: "Maintenance Status",
  monthlyReports: "Monthly Reports",
  statistics: "Statistics",
  createReport: "Create Report",
  pendingWork: "Pending Work",
  viewReportStatistics: "View Report Statistics",
  totalExcavators: "Total Machines",
  activeExcavators: "Active Machines",
  totalReports: "Total Reports",
  pendingReports: "Pending Reports",
  loadingDashboard: "Loading dashboard data...",
  failedToLoadDashboard: "Failed to load dashboard data. Please try again.",
  viewAll: "View All",
  recentReports: "Recent Reports",
  thisMonth: "This Month",
  monthlyTarget: "Monthly Target",
  criticalMachines: "Critical Machines",
  lastMaintenanceType: "Last Service Type",
  machineStatus: "Machine Status",
  noCriticalMachines: "No machines need urgent maintenance",
  noMachineCritical: "No machines need urgent maintenance",
  active: "active",
  critical: "critical",
  fileNewReport: "File a new maintenance report",
  registerNewExcavator: "Register a new excavator",
  viewUnsignedReports: "View all unsigned reports",
  viewDetailedAnalytics: "View detailed reports analytics",
  daysSince: "Days Since",
  scheduled: "Scheduled",

  // Filter and Search
  filter: "Filter",
  search: "Search",
  searchPlaceholder: "Search by model, manufacturer, serial number...",
  clear: "Clear",
  all: "All",
  upToDate: "Up to Date",
  maintenanceDue: "Maintenance Due",
  overdue: "Overdue",
  resetFilters: "Reset Filters",
  applyFilters: "Apply Filters",
  never: "Never",

  // Report Detail Page
  loadingReport: "Loading report...",
  failedToLoadReport: "Failed to load report",
  errorDownloadingPDF: "Error downloading PDF",
  signatureRequired: "Signature required",
  nameRequired: "Name required",
  reviewerName: "Reviewer Name",
  clearSignature: "Clear Signature",
  saveSignature: "Save Signature",
  enterYourName: "Enter your name",
  onlyManagersCanApprove: "Only managers can approve reports",
  downloading: "Downloading...",
  downloadPDF: "Download PDF",
  approveReport: "Approve Report",
  editReport: "Edit Report",
  maintenanceReportDetails: "Maintenance Report Details",
  back: "Back",
  reportNotFound: "Report Not Found",
  reportNotFoundMessage: "The requested report could not be found",
  viewAllReports: "View All Reports",
  approveMaintenanceReport: "Approve Maintenance Report",
  managerName: "Manager Name",
  createdOn: "Created on",
  excavatorInformation: "Machine Information",
  unknown: "Unknown",
  "n/a": "Not specified",
  serviceInformation: "Service Information",
  serviceType: "Service Type",
  equipmentHours: "Equipment Hours",
  location: "Location",
  routine: "Routine",
  exterior: "Exterior",
  interior: "Interior",
  engine: "Engine",
  cleaning: "Cleaning",
  notes: "Notes",
  checklist: "Checklist",
  item: "Item",
  additionalNotes: "Additional Notes",
  noAdditionalNotesProvided: "No additional notes provided",
  signatures: "Signatures",
  technicianSignature: "Operator Signature", // Updated from "Technician Signature"
  noSignatureAvailable: "No signature available",
  signedBy: "Signed by",
  managerApproval: "Manager Approval",
  approvedBy: "Approved by",
  thisReportIsWaitingForYourApproval:
    "This report is waiting for your approval",
  pendingManagerApproval: "Pending manager approval",
  signAndApproveNow: "Sign and approve now",
  processing: "Processing...",
  sign: "Sign",
  noInspectionDataAvailableFor: "No inspection data available for",
  notSpecified: "Not specified",
  tryAgain: "Try again",
  generalInformation: "General Information",
  technicalDetails: "Technical Details",
  maintenanceChecklist: "Maintenance Checklist",
  operatingHours: "Operating Hours",
  hours: "hours",
  maintenanceType: "Maintenance Type",
  reviewedBy: "Reviewed by",
  signedDate: "Signed Date",
  hydraulic: "Hydraulic",
  routineMaintenance: "Routine Maintenance",
  failedToApproveReport: "Failed to approve report",
  reportApprovedSuccessfully: "Report approved successfully",
  specialChecksSummary: "Special Checks Summary",

  // Create Report Page
  createMaintenanceReport: "Create Maintenance Report",
  selectExcavator: "Select Machine",
  pleaseSelectExcavator: "Please select a machine",
  reportDetails: "Report Details",
  maintenanceDate: "Maintenance Date",
  nextMaintenanceDate: "Next Maintenance Date",
  technicianName: "Operator Name", // Updated to use "Operator"
  inspectionChecklist: "Inspection Checklist",
  exteriorChecks: "Exterior Checks",
  interiorChecks: "Interior Checks",
  engineChecks: "Engine Checks",
  hydraulicChecks: "Hydraulic Checks",
  notApplicable: "Not Applicable",
  notDone: "Not Done",
  additionalComments: "Additional Comments",
  submitReport: "Submit Report",
  pleaseAddSignature: "Please add your signature",
  pleaseSelectDate: "Please select a date",
  reportSubmittedSuccessfully: "Report submitted successfully",
  failedToSubmitReport: "Failed to submit report",
  submitting: "Submitting...",

  // Chart labels
  chartReportsByMonth: "Reports Filed by Month",
  chartNumberOfReports: "Number of Reports",
  itemsCompleted: "Items Completed",
  completionStatus: "Completion Status",
  checksCompleted: "Checks Completed",
  notesAdded: "Notes Added",

  // Statistics page
  topOperators: "Top Operators",
  maintenanceByMachine: "Maintenance by Machine",
  approvalTime: "Approval Time",
  averageTimeToApproveReport: "Average time from creation to approval",
  maintenanceIntervals: "Maintenance Intervals",
  averageTimeBetweenMaintenances: "Average time between maintenance reports",
  days: "days",
  between: "between",
  average: "average",
  serviceTypes: "Service Types",
  avgOperatingHours: "Avg. Operating Hours",
  print: "Print",
  overview: "Overview",
  machines: "Machines",
  personnel: "Personnel",
  predictions: "Predictions",
  daysSinceLastMaintenance: "Days Since Last Maintenance",
  recommendedAction: "Recommended Action",
  scheduleMaintenance: "Schedule Maintenance ASAP",
  planMaintenance: "Plan Maintenance Soon",
  normalMaintenance: "Regular Schedule",
  avgReportsPerMonth: "Avg. Reports/Month",
  reportTypes: "Report Types",
  operatorPerformance: "Operator Performance",
  upcomingMaintenances: "Upcoming Maintenances",
  noUpcomingMaintenancesPredicted:
    "No upcoming maintenances predicted in the next 60 days",
  predictedNextDate: "Predicted Next Date",
  daysUntilDue: "Days Until Due",
  yearlyComparison: "Yearly Comparison",
  inspection: "Inspection",
  total: "total",
  maintenanceByType: "Maintenance by Type",

  // Additional translations for both pages
  user: "User",
  pending: "pending",

  // Report checklist items
  chassis: "Chassis",
  boom: "Boom",
  bucket: "Bucket",
  hydraulics: "Hydraulics",
  mirrors: "Mirrors",
  windows: "Windows",
  cameras: "Cameras",
  lights: "Lights",
  wipers: "Wipers",
  lubricationSystem: "Lubrication System",
  seat: "Seat",
  electronics: "Electronics",
  heating: "Heating",
  airConditioning: "Air Conditioning",
  joystick: "Joystick",
  display: "Display",
  controls: "Controls",
  parkingBrake: "Parking Brake",
  engineOil: "Engine Oil",
  hydraulicOil: "Hydraulic Oil",
  coolant: "Coolant",
  windshieldWasher: "Windshield Washer",
  transmissionOil: "Transmission Oil",
  fuelFilter: "Fuel Filter",
  airFilter: "Air Filter",
  washed: "Washed",
  windowsCleaned: "Windows Cleaned",
  mirrorsCleaned: "Mirrors Cleaned",
  interiorWindowsCleaned: "Interior Windows Cleaned",
  interiorWiped: "Interior Wiped",
  interiorVacuumed: "Interior Vacuumed",
  fuelLevel: "Fuel Level",
  startDate: "Start Date",
  endDate: "End Date",
  nextInspectionDate: "Next Inspection Date",

  // Betriebstagebuch (Operating Journal)
  betriebstagebuch: "Operating Journal",
  betriebstagebuchList: "Operating Journal List",
  createBetriebstagebuch: "Create Operating Journal Entry",
  editBetriebstagebuch: "Edit Operating Journal Entry",
  viewBetriebstagebuch: "View Operating Journal Entry",
  betriebstagebuchDetails: "Operating Journal Details",
  conveyorChecks: "Conveyor Checks",
  conveyorName: "Conveyor Name",
  functional: "Functional",
  notFunctional: "Not Functional",
  conveyorNotes: "Notes for this conveyor",
  generalNotes: "General Notes",
  addConveyor: "Add Conveyor",
  removeConveyor: "Remove",
  noConveyorsAdded: "No conveyors have been added yet",
  entryDate: "Entry Date",
  createdBy: "Created By",
  creator: "Creator",
  reviewer: "Reviewer",
  reviewerSignature: "Reviewer Signature",
  creatorSignature: "Creator Signature",
  betriebstagebuchCreated: "Operating Journal entry created successfully",
  betriebstagebuchUpdated: "Operating Journal entry updated successfully",
  betriebstagebuchApproved: "Operating Journal entry approved successfully",
  betriebstagebuchDeleted: "Operating Journal entry deleted successfully",
  downloadBetriebstagebuchPDF: "Download PDF",
  approveBetriebstagebuch: "Approve Entry",
  recyclingCenter: "Recycling Center",
  sortingMachine: "Sorting Machine",
  allConveyorsMustBeNamed: "All conveyors must be named",
  errorSavingEntry: "Error saving entry",
  quickView: "Quick View",
  tryChangingFilters: "Try changing the filters",
  conveyorChecksSummary: "Conveyor Checks Summary",
  noSpecialChecksRecorded: "No special checks recorded",
  backToList: "Back to List",
  reviewedOn: "Reviewed On",
  rowsPerPage: "Rows per page",
  of: "of",
  searchExcavatorsPlaceholder: "Search by model, manufacturer, serial number or type...",
  searchBy: "Search by",
  noMatchingResults: "No matching results found",
  clearSearch: "Clear Search",
  batchGenerateBetriebstagebuch: "Batch Generate Operating Journals",
  createMultipleEntries: "Create multiple entries at once",
  dateRange: "Date Range",
  addNewUser: "Add New User",
  nextMaintenance: "Next Maintenance",
  daysInRange: "Days in Range",
  entriesToBeGenerated: "Entries to be Generated",
  allEntriesWillHaveYourSignature: "All entries will have your signature",
  generateEntries: "Generate Entries",
  generating: "Generating...",
  generatedEntries: "Generated Entries",
  betriebstagebuchEntriesGenerated: "Operating Journal entries generated successfully",
  errorGeneratingEntries: "Error generating Operating Journal entries",
  dayOfWeek: "Day of Week",
  pleaseSelectDateRange: "Please select a date range",
  endDateMustBeAfterStartDate: "End date must be after start date",
  onlyAdminsCanBatchGenerate: "Only administrators can batch generate Operating Journals",
  allConveyorsWillBeAddedToEachEntry: "All conveyors will be added to each entry",
  weekendsAreExcluded: "Weekends (Saturday and Sunday) are automatically excluded",
  preview: "Preview",
  allSpecialChecksMustBeNamed: "All special checks must be named",
  specialCheckNotes: "Notes for this check",
  checkName: "Check Name",
  notCompleted: "Not Completed",

  // Conveyor Names (kept in German for consistency)
  AT: "AT",
  Steigband: "Steigband",
  Trommel: "Trommel",
  HeckBand: "HeckBand",
  SortierBand: "SortierBand",
  MagnetSortierHaus: "MagnetSortierHaus",
  MagnetHalle: "MagnetHalle",
  SeitenBand: "SeitenBand",
  Zuführband: "Zuführband",
  TrommelWindsichter: "TrommelWindsichter",
  SpeedBand: "SpeedBand",
  Airlift: "Airlift",
  Airwheel: "Airwheel",
  Ventilator: "Ventilator",

  // Machine Overview/Details
  description: "Description",
  updateHours: "Update Hours",
  updateOperatingHours: "Update Operating Hours",
  featureComingSoon: "Feature Coming Soon",
  uvvStatus: "UVV Status", // UVV is likely a German regulation (Unfallverhütungsvorschrift)
  nextInspection: "Next Inspection",
  noDescription: "No description available",
  noNotes: "No notes available",
  noData: "No data available",
  gallery: "Gallery",
  attachments: "Attachments",
  comments: "Comments",
  relatedEquipment: "Related Equipment",
  select: "Select",
  assign: "Assign",
  schedule: "Schedule",

  // Bulk Sign Errors
  reportsAvailable: "reports available",
  bulkSignErrorTitle: "Bulk Sign Error",
  currentUserDataMissingError: "User data missing for bulk sign operation.",

  // Missing placeholders and fallback strings
  appName: "FleetPilot",
  shiftStartPlaceholder: "e.g. Early shift, 06:00",
  shiftEndPlaceholder: "e.g. Late shift, 14:00",
  weatherPlaceholder: "e.g. Sunny, light wind",
  temperaturePlaceholder: "e.g. 15",
  fuelLevelPlaceholder: "e.g. 75%",
  foreignMaterialControl: "Own, Foreign, and Delivery Control",
  noIncidents: "No incidents",
  fetchingWeatherData: "Loading weather data...",
  sunny: "Sunny",

  // Additional missing translations from form validations and operations
  signatureCannotBeEmpty: "Signature cannot be empty",
  noProfileSignatureAvailable: "No profile signature available",
  managersOnlyCanCreateBTB: "Only managers can create operating journal entries",
  pleaseCorrectFormErrors: "Please correct form errors",
  errorFetchingEntry: "Error fetching entry",
  loadingEntry: "Loading entry...",
  accessDenied: "Access Denied",
  saving: "Saving...",
  saved: "Saved",
  updateEntry: "Update Entry",
  saveEntry: "Save Entry",
  entryUpdatedSuccess: "Entry updated successfully",
  entryCreatedSuccess: "Entry created successfully",
  general: "General",
  conveyorNameRequired: "Conveyor name is required",
  checkNameRequired: "Check name is required",
  dateIsRequired: "Date is required",
  signatureIsRequired: "Signature is required",

  // User Management missing translations
  errorFetchingUsers: "Error fetching users",
  nameIsRequired: "Name is required",
  emailIsRequired: "Email is required",
  invalidEmailFormat: "Invalid email format",
  passwordIsRequiredForNewUser: "Password is required for new users",
  userCreatedSuccessfully: "User created successfully",
  userUpdatedSuccessfully: "User updated successfully",
  errorSavingUser: "Error saving user",
  userDeletedSuccessfully: "User deleted successfully",
  errorDeletingUser: "Error deleting user",
  manageUsers: "Manage Users",
  searchUsers: "Search Users",
  allRoles: "All Roles",
  noMatchingUsers: "No matching users found",
  noUsersFound: "No users found",
  createNewUser: "Create New User",
  newPasswordOptional: "New Password (optional)",
  leaveBlankNoChange: "Leave blank to keep current password",
  confirmUserDeletion: "Confirm User Deletion",
  areYouSureDeleteUser: "Are you sure you want to delete {{name}}?",
  thisActionCannotBeUndone: "This action cannot be undone.",

  // Statistics page missing translations
  errorFetchingStats: "Error fetching statistics",
  noDataToExport: "No data to export",
  csvExportedSuccessfully: "CSV exported successfully",
  statisticsAndReports: "Statistics and Reports",
  applicationStatistics: "Application Statistics",
  printPage: "Print Page",
  reportType: "Report Type",
  allExcavators: "All Machines",
  allTypes: "All Types",
  reportStatusDistribution: "Report Status Distribution",
  machineSpecificStatsComingSoon: "Machine-specific statistics coming soon",
  personnelSpecificStatsComingSoon: "Personnel-specific statistics coming soon",
  betriebstagebuchTotal: "Operating Journal Total",

  // Batch generation missing translations
  configurationTemplate: "Configuration Template",
  dateRangeForGeneration: "Date Range for Generation",
  weekendsAreExcludedInfo: "Weekends (Saturday and Sunday) are automatically excluded",
  dailyEntryTemplate: "Daily Entry Template",
  defaultConveyorChecks: "Default Conveyor Checks",
  allConveyorsWillBeAddedInfo: "All conveyors will be added to each entry",
  signatureRequiredForGeneration: "Signature required for generation",
  noWorkdaysInRange: "No workdays in range",
  adminsOnlyCanAccessBatch: "Only administrators can access batch generation",

  // Footer missing translations
  footerDescription: "Professional equipment management and maintenance tracking system for heavy machinery and excavators.",
  allRightsReserved: "All rights reserved.",

  // Additional component translations
  maker: "Maker",
  quantity: "Quantity",
  selectFile: "Select File",
  removeImage: "Remove Image",
};

export default translations;
